// --------------------------------------------------------------------------
// ajaxForm.js
// --------------------------------------------------------------------------
// AJAX form results
// --------------------------------------------------------------------------

RN.ajaxForm = function() {

    'use strict';

    var page = 1;

    function init() {
        var selectTrigger = byBehaviour("ajax-form").find("select");
        var buttonTrigger = byBehaviour("ajax-button");
        var results = byElement("ajax-form-results");

        byBehaviour("ajax-form").on('submit', function(e){
            e.preventDefault();
            resetFilteringAfter();
            fetchResults(results, buttonTrigger, true);
            $('input[type=search]').blur();
        });

        selectTrigger.on('change', function(e){
            e.preventDefault();
            fetchResults(results, buttonTrigger, true);
        });

        buttonTrigger.on('click', function(e) {
            e.preventDefault();
            fetchResults(results, buttonTrigger, false);      
        });
    }

    function resetFilteringAfter() {
        var resetSelect = byElement("ajax-form-filtering-after").find("select");
        resetSelect.val("").trigger('selectron.change'); // reset any after-search filters and update selectron UI
    }

    function fetchResults(results, buttonTrigger, pageReset) {
        results.css({opacity:0.5});
        byElement("ajax-form-filtering-after").hide();        
        buttonTrigger.html('Loading...');

        page++;

        if(pageReset) {
            page = 1;
        }

        var url = buttonTrigger.data("url");
        var path = buttonTrigger.data("path");
        var tag = buttonTrigger.data("tag");
        if(!url) {
            url = byBehaviour("ajax-form").attr("action");
        }
        if(!path) {
            path = "";
        }

        $.ajax({
            'url': url + path,
            'method':'POST',
            'data': byBehaviour("ajax-form").serialize() + "&page=" + page + "&tag=" + tag,
            'dataType':'json',
            'success': function (response) {

                buttonTrigger.html('Load more');
                var items = $(response.html);
                var hasNextPage = response.hasNextPage;

                byElement("results-count").html(response.totalResults);
                if(response.totalResults > 0) {
                    byElement("ajax-form-filtering-after").show();
                }

                if(pageReset) {
                    results.html(items);
                    buttonTrigger.show();
                }
                else {
                    results.append(items);
                }

                if(!hasNextPage) {
                    buttonTrigger.hide();
                }

                if(byBehaviour('faint-filter-toggle').length){
                    byBehaviour('faint-filter-toggle').trigger('click');
                }
                else {
                    if(!buttonTrigger.data('no-scroll')){
                        $('html, body').stop().animate({
                            scrollTop: results.offset().top + 'px'
                        }, 500);
                    }
                }

                

                results.css({opacity:1});
           
            }
        });
    }

    return {
        init: init
    };

}();